import { Footer } from "@faire/deprecated-retailer-visitor-shared/components/Footer/index";
import * as React from "react";

export const FooterSEOContent: React.FC = () => {
  return <Footer noTopBorder />;
};
